import React, { FC } from 'react';
import FlexGroup from './FlexGroup';
import FlexItem from './FlexItem';

interface TableViewLayoutProps {
  searchInput: React.ReactNode;
  filterAndColumnControls: React.ReactNode;
  table?: React.ReactNode;
}

const TableViewLayout: FC<TableViewLayoutProps> = ({ searchInput, filterAndColumnControls, table }) => {
  return (
    <FlexGroup padding={'0'} direction="row" data-testid="table-view-layout">
      <FlexItem grow={1} shrink={1} css={{ width: '100%' }}>
        <FlexGroup direction="column" gapSize="4" padding="0">
          <FlexItem grow="0" shrink="0" css={{ overflow: 'hidden' }}>
            <FlexGroup
              alignItems="center"
              justifyContent="space-between"
              direction="row"
              gapSize="2"
              padding="0"
              css={{ overflow: 'hidden' }}
            >
              <div>{searchInput}</div>
              <div>{filterAndColumnControls}</div>
            </FlexGroup>
          </FlexItem>
          <FlexItem grow={1} shrink={1}>
            <FlexGroup padding="0">
              <FlexItem>{table}</FlexItem>
            </FlexGroup>
          </FlexItem>
        </FlexGroup>
      </FlexItem>
      <FlexItem grow="1" shrink={'0'}>
        <FlexGroup>
          <div id="flyin-portal"></div>
        </FlexGroup>
      </FlexItem>
    </FlexGroup>
  );
};

export default TableViewLayout;
